import { Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const variants = {
  primary: 'bg-beam-blue text-white shadow-glow hover:bg-beam-violet',
  light: 'bg-white text-beam-ink hover:bg-beam-light',
  outline: 'border border-beam-blue/20 bg-white/70 text-beam-ink hover:border-beam-blue hover:bg-white',
  dark: 'bg-beam-ink text-white hover:bg-beam-graphite',
  danger: 'bg-state-critical text-white hover:bg-state-critical/90',
  ghost: 'text-beam-graphite hover:bg-beam-light',
  // The two variants above read as invisible on a dark hero, and overriding their
  // colours through className is a coin toss on which utility Tailwind emits last.
  outlineLight: 'border border-white/25 text-white hover:border-white hover:bg-white/10',
  ghostLight: 'text-white/75 hover:bg-white/10 hover:text-white',
};

export const Button = ({
  as: Component = 'button',
  to,
  href,
  variant = 'primary',
  size = 'md',
  icon: Icon,
  loading = false,
  disabled = false,
  children,
  className = '',
  ...props
}) => {
  const sizeClass = size === 'sm' ? 'px-3 py-2 text-xs' : 'px-5 py-3 text-sm';
  const classes = `focus-ring inline-flex items-center justify-center gap-2 rounded-lg font-bold transition disabled:cursor-not-allowed disabled:opacity-55 ${sizeClass} ${variants[variant]} ${className}`;
  const LeadingIcon = loading ? Loader2 : Icon;
  const content = (
    <>
      {LeadingIcon ? (
        <LeadingIcon className={`h-4 w-4 shrink-0 ${loading ? 'animate-spin' : ''}`} aria-hidden="true" />
      ) : null}
      <span>{children}</span>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {content}
      </a>
    );
  }

  return (
    <Component className={classes} disabled={disabled || loading} aria-busy={loading || undefined} {...props}>
      {content}
    </Component>
  );
};
